import React from "react";
import { Icon } from "@unite-us/app-components";
import InboxTypes from "../../../utils/enums/inboxTypes.enum";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const EmptyInbox = _ref => {
  let {
    inboxType
  } = _ref;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: "flex flex-1 justify-center items-center",
      children: /*#__PURE__*/_jsx("div", {
        className: "ml-5 mr-10",
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Icon, {
            className: "h-56 w-56",
            icon: "NoMessages"
          }), /*#__PURE__*/_jsxs("h4", {
            className: "text-center mt-6 text-lg",
            children: ["Your ", inboxType === InboxTypes.INBOX ? 'inbox' : 'archive', " is empty."]
          })]
        })
      })
    })
  });
};
export default EmptyInbox;
//# sourceMappingURL=EmptyInbox.js.map